export default {
  // ========== Titles and headers ==========
  selectEgressProfile: 'Select a {entity}',
  noAssociatedEgressProfiles: 'There are no {entity} associated with your user.',

  // ========== Information and tooltips ==========
  specificEgressProfileMatters: 'These {entity} are specific to exit profiles that can be unique or shared.',
  baseMattersInfo: 'These are the {entity} that can be used in several Exit Profiles, replicating their learning outcomes.',

  // ========== Table fields ==========
  code: 'Code',
  order: 'Order',
  weeks: 'Weeks',
  planLevel: 'Plan Level',
  profile: 'Profile',
  profileType: 'Profile Type',
  studyUnits: 'Study units',

  // ========== Actions and buttons ==========
  saveComment: 'Save comment',
  viewVersion: 'View version',
  applyVersion: 'Apply version',
  deleteVersion: 'Delete version',
  versions: 'Versions',

  // ========== Confirmation messages ==========
  sureToApplyVersion: 'Are you sure you want to apply this version?',
  sureToDeleteVersion: 'Are you sure you want to delete this version?',
  irreversibleChange: 'This change is irreversible.',

  // ========== Success messages ==========
  versionUpdated: 'Version updated!',
  versionDeleted: 'Version deleted!',
  changesSavedSuccessfully: 'Changes saved successfully.',

  // ========== Error messages ==========
  changeNotApplied: 'The change was not applied',

  // ========== History fields ==========
  modificationDate: 'Modification date',
  user: 'User',
  comment: 'Comment',
  applied: 'Applied',
  view: 'View',

  // ========== Profile information ==========
  noAffiliatedToEgressProfile: 'Not affiliated to any exit profile.',
  noStudyUnits: 'No study units',
  profileNotFound: 'Profile not found.',
  profileTypeNotFound: 'Profile type not found.',

  // ========== Reversion messages ==========
  revertedToVersion: 'Reverted to previous version, saved on:',

  // ========== State messages ==========
  changeStateTooltip: 'Change the state of the {entity}',
  noHas: 'Does not have',

  // ========== File update ==========
  updateExcel: 'Update excel {entity}',
  uploading: 'Uploading...',
  pleaseWaitUpload: 'Please wait while the file is being uploaded.',
  fileUploadedSuccessfully: 'File uploaded successfully!',
  problemUploadingFile: 'There was a problem uploading the file!',
}
